import { render, staticRenderFns } from "./CommunicationList.vue?vue&type=template&id=79cdb25c&"
import script from "./CommunicationList.vue?vue&type=script&lang=ts&"
export * from "./CommunicationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cdb25c')) {
      api.createRecord('79cdb25c', component.options)
    } else {
      api.reload('79cdb25c', component.options)
    }
    module.hot.accept("./CommunicationList.vue?vue&type=template&id=79cdb25c&", function () {
      api.rerender('79cdb25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/communications/CommunicationList.vue"
export default component.exports